import { ChangeEvent, useCallback } from 'react';
import { Box, MenuItem, TextField, Tooltip } from '@mui/material';
import { ALL_PRODUCTS, PRODUCT_SELECTION_OPTIONS } from 'pages/AuditLogs/constants';
import { ProductSelection } from 'pages/AuditLogs/types';

const ProductFilter = ({
  value,
  onChange,
}: {
  value: ProductSelection;
  onChange: (value: ProductSelection) => void;
}) => {
  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      onChange(event.target.value as ProductSelection);
    },
    [onChange]
  );

  const renderValue = useCallback((selection: unknown) => {
    const typedSelection = selection as ProductSelection;
    const selectedOption = PRODUCT_SELECTION_OPTIONS.find(option => option.value === typedSelection);
    const selectedLabel = selectedOption?.label ?? typedSelection;

    return (
      <Tooltip title={selectedLabel} placement="top">
        <Box
          component="span"
          sx={{
            display: 'block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}>
          {selectedLabel}
        </Box>
      </Tooltip>
    );
  }, []);

  return (
    <Box sx={{ width: 220 }}>
      <TextField
        select
        fullWidth
        id="audit-logs-product-filter"
        label="Product"
        value={value ?? ALL_PRODUCTS}
        onChange={handleChange}
        slotProps={{ select: { renderValue } }}>
        {PRODUCT_SELECTION_OPTIONS.map(option => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </TextField>
    </Box>
  );
};

export default ProductFilter;
